import paginate from '@/shared/utils/plugins/paginate/paginate.js';

export { paginate };
